import { ActionTypes, useAuth, UserPermission } from '@services/auth'
import history from '@shared/innmaxLib/routes/history'
import { pathOr } from 'ramda'

export default function useRouteAuth() {
  const { user } = useAuth()

  const pathname =
    history.location.pathname === '/' ? '/dashboard' : history.location.pathname

  const routeAuth = pathOr({}, ['authByUrl', pathname], user) as UserPermission

  return [
    routeAuth,
    (actionType: ActionTypes) =>
      process.env.NODE_ENV === 'development' ? true : routeAuth[actionType],
  ] as [UserPermission, (act: string) => boolean]

  // return [routeAuth, (act: ActionTypes) => routeAuth[act]] as [
  //   UserPermission,
  //   (act: string) => boolean
  // ]
}
